<!-- Backdrop -->
<div
  class="attachment-drawer-backdrop"
  *ngIf="isOpen"
  (click)="close()">
</div>

<!-- Drawer -->
<aside class="attachment-drawer" [class.open]="isOpen" role="dialog" aria-label="Attachment preview">
  <header class="attachment-drawer-header">
    <div class="attachment-drawer-title">
      <span class="attachment-drawer-filename" *ngIf="currentChip">{{ currentChip.Filename }}</span>
      <span class="attachment-drawer-counter" *ngIf="chips.length > 1">
        {{ currentIndex + 1 }} of {{ chips.length }}
      </span>
    </div>
    <div class="attachment-drawer-controls">
      <button
        type="button"
        class="attachment-drawer-nav"
        [disabled]="currentIndex === 0"
        (click)="previous()"
        aria-label="Previous attachment">
        <i class="fa-solid fa-chevron-left"></i>
      </button>
      <button
        type="button"
        class="attachment-drawer-nav"
        [disabled]="currentIndex >= chips.length - 1"
        (click)="next()"
        aria-label="Next attachment">
        <i class="fa-solid fa-chevron-right"></i>
      </button>
      <button
        type="button"
        class="attachment-drawer-close"
        (click)="close()"
        aria-label="Close">
        <i class="fa-solid fa-xmark"></i>
      </button>
    </div>
  </header>

  <div class="attachment-drawer-body">
    <mj-artifact-viewer-panel
      *ngIf="currentChip"
      [artifactId]="currentChip.ArtifactID"
      [currentUser]="currentUser"
      [environmentId]="environmentId"
      [showSaveToCollection]="false"
      [showHeader]="false"
      [showCloseButton]="false"
      [showMaximizeButton]="false">
    </mj-artifact-viewer-panel>
  </div>
</aside>
